exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".folded:not(.folded-open) :host > .group-title {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center; }\n  .folded:not(.folded-open) :host > .group-title > span {\n    opacity: 0;\n    -webkit-transition: opacity 200ms ease;\n    transition: opacity 200ms ease; }\n  .folded:not(.folded-open) :host > .group-title:before {\n    content: '';\n    display: block;\n    position: absolute;\n    min-width: 1.6rem;\n    border-top: 2px solid;\n    opacity: 0.2; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/NeoSME/1.Full Project Spekwo/pro/prodash/src/app/core/components/navigation/vertical/nav-group/nav-vertical-group.component.scss
// module id = ../../../../../src/app/core/components/navigation/vertical/nav-group/nav-vertical-group.component.scss
// module chunks = main